import Cookies from 'js-cookie'

import { type CookieConsent, CookieKeys } from '@/configs/cookies'

export function readStoredCookieConsent(): CookieConsent | null {
  const raw = Cookies.get(CookieKeys.COOKIE_CONSENT)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw) as CookieConsent
  } catch {
    return null
  }
}

export function hasTrackingConsent(): boolean {
  const consent = readStoredCookieConsent()
  return Boolean(consent?.analytics || consent?.advertising)
}
